import * as React from "react"
import { Link as RouterLink } from "react-router-dom"

interface LinkProps {
  url: string
  className?: string
  handle?: () => void
  external?: boolean
  title?: string
}

export const Link: React.StatelessComponent<LinkProps> = props => {
  let onClick = () => props.handle && props.handle()
  let className = `${props.className ? props.className : ""}`
  let parser = document.createElement("a")
  parser.href = props.url
  let decodedUrl = `${parser.origin}${parser.pathname}${decodeURIComponent(parser.search)}`
  return props.url.substr(0, 4) === "http" || props.external ? (
    <a href={decodedUrl} className={className} onClick={onClick} target="_blank" rel="noopener noreferrer" title={props.title}>
      {props.children}
    </a>
  ) : (
    <RouterLink to={props.url} className={className} onClick={onClick} title={props.title}>
      {props.children}
    </RouterLink>
  )
}

{/* TH: Added to styleguide! */}
